<template>
    <div class="admin__driver__context">
        <div v-if="popup">
            <driver-pop-up v-if="popup" @closePopup="hidePop" :driver="activeDriver" :id="activeDriver.id" :status="activeDriver.status"></driver-pop-up>
        </div>
        <div class="content" v-if="!popup">
            <h1>Drivers</h1>
            <div class="table__content">


                <div class="search__content">
                    <label>Show rows
                      <select class="input-filed perpage__value__section" name="perpage__field" v-model="perPage"  @change="changePerpage($event)">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option :value="drivers.length">All</option>
                        </select>
                    </label>
                    <input id='search__field' @keyup.enter="search" class="search__value__section" type="text" placeholder="Search" v-model="searchParameter" :onchange="checkInput()">
                    <button @click="search" class="btn__search">Search</button>
                </div>
                 <div class="table__container">
                    <table style="width: 100%">
                        <tr>
                            <th style="width: 12%;">
                                <span style="padding-left: 15px;">
                                  {{this.isMobile() ? 'ID': 'DRIVER ID' }}

                                    <div @click="sort(0)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                            <th>
                                <span>
                                  {{this.isMobile() ? 'NAME': 'DRIVER NAME' }}

                                    <div @click="sort(1)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                            <th>
                                <span>
                                  {{this.isMobile() ? 'DRIVEN': 'HOURS DRIVEN' }}

                                    <div @click="sort(2)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                            <th>
                                <span>
                                    PAYOUTS
                                    <div @click="sort(4)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                            <th>
                                <span>
                                 STATUS

                                    <div @click="sort(3)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                            <th>
                                <span>
                                      {{this.isMobile() ? 'PROJECTOR': ' PROJECTOR IDs' }}


                                    <div @click="sort(5)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div>
                                </span>
                            </th>
                        </tr>
                        <tr v-for="driver in paginationDrivers" v-bind:key="driver.id" class="table__data" @click="popUpDriver(driver)">
                            <td>{{driver.id}}</td>
                            <td>{{driver.name}}</td>
                            <td class="driver__hours__value">{{driver.hours}}</td>
                            <td class="driver__payouts__value">{{driver.payouts}}</td>
                            <td class="driver__status__value">
                                <div v-bind:class="[driver.status ? 'approved__status' : 'inactive__status']" style="width: 16px; height: 16px; border-radius: 15px;"></div>
                            </td>
                            <td style="font-size: 9px;">
                                <div v-if="driver.driver_projector != ''">
                                    Projector ID Driver - {{driver.driver_projector}}
                                </div>
                                <div v-if="driver.passenger_projector != ''">
                                    Projector ID Passenger - {{driver.passenger_projector}}
                                </div>
                            </td>
                        </tr>
                    </table>
                    <paginate
                        v-if="drivers.length > 0"
                        v-model="driverNumber"
                        :page-count="driverTotal"
                        :container-class="'paginationContainer'"
                        :active-class="'paginationActive'"
                        :click-handler="driverPaggination">
                    </paginate>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import toast from '@utils/toast.js'
import DriverPopUp from './AdminDriversPopUp.vue'
import store from '@store/index.js'
import Search from '@utils/Search.js'
import { paginateList, paginationTotal } from '@utils/pagination.js'
export default {
  name: 'AdminDrivers',
  data: function () {
      return {
          popup: false,
          drivers: [],
          driverData: {},
          driversSearch: [],
          searchParameter: '',
          startParameter: false,
          sorts: [false, false, false, false, false, false],
          activeDriver: {},
          driverNumber: 1,
          driverTotal: 1,
          driverID: null,
          driverStatus: null,
          perPage: 5,
          initial: false,
      }
  },
  components: {
      DriverPopUp
  },
  methods: {
      getDrivers (initial) {
          let data = {}
          this.request('/admin/list/drivers', 'POST', data).then((response) => {
              if (response.code === 0) {
                  toast.successMessage('Data is received')

                  this.drivers = response.data
                  this.driversSearch = this.drivers
                  if(initial === true){
                      this.initial =true
                       this.sorts[0] = true
                        this.sort(0)
                  }
                  this.setTotalPagginationLength()

              } else {
                  toast.errorMessage(response.message)
                  if (response.code === 112) {
                      this.checkTokenConditions(this.getDrivers(initial))
                  }
              }
          }).catch((error) => {
              toast.errorMessage(error)
          })
      },
      checkTokenConditions (callback) {
        try{
            var expiresDate = new Date(this.token.expires)
        } catch (err) {
            this.$router.push('/login')
        }
        var now = new Date()
        if (expiresDate <= now) {
            this.store.commit('setToken', {})
            this.$router.push('/login')
        } else {
            var body = {
            code: '',
            refresh_token: this.token.refresh_token
            }
            this.request('/refresh/token', 'POST', body).then((response) => {
            if (response.code === 0 ) {
                store.commit('setToken', response.data[0])
                store.commit('setDriver', response.data[0].driver)
                this.callback()
            } else if (response.code === 112) {
                this.store.commit('setToken', {})
                this.$router.push('/login')
            }
            }).catch((error) => {
            })
        }
        var token = this.token
        token.redirect = false
        this.store.commit('setToken', token)
      },
      search () {
        if (this.searchParameter !== '') {

            var inputFileds = null
            var string = false
            if (isNaN(this.searchParameter)) {
                inputFileds = [1]
                string = true
            } else {
                inputFileds = [0, 2, 4, 5, 6]
                this.searchParameter = parseInt(this.searchParameter)
            }
            var searchObject = new Search(inputFileds, this.driversSearch, this.searchParameter, Object.keys(this.driversSearch[0]), string, [])
            searchObject.search().then((value) => {
              console.log("OBJJJJJJJJJJJ SS",value)
                if (value.length === 0) {
                    toast.simpleMessage('No result found from the search')
                } else {
                    toast.successMessage('Search result received')
                }
                this.drivers = value
                this.setTotalPagginationLength()
            })
        }
      },
      checkInput () {
        if ( this.searchParameter === '' && this.startParameter) {
            this.drivers = this.driversSearch
            this.setTotalPagginationLength()
        } else {
            if (this.searchParameter.length > 0) {
                this.startParameter = true
            }
        }
      },
      sort (value) {
            //  console.log(this.sorts[value])
            this.sorts[value] = !this.sorts[value]
            //console.log(this.sorts[value])
            if(  this.initial === false){
                if (this.sorts[value]) {
                    toast.simpleMessage('Sort type: Ascending')
                } else {
                    toast.simpleMessage('Sort type: Descending')
                }
            }

            this.drivers.sort((a, b) => {
                return b[Object.keys(b)[value]] < a[Object.keys(a)[value]] ? !this.sorts[value] ? -1 : 1
                : b[Object.keys(b)[value]] > a[Object.keys(a)[value]] ? this.sorts[value] ? -1 : 1
                : 0
            })
      },
      popUpDriver (driver) {
          this.popup = true
          this.activeDriver = driver
      },
      hidePop (isUpdated) {
          this.popup = false
          if(Object.keys(isUpdated).length != 0){
          const oldItemIndex=this.drivers.find(el => el.id == isUpdated.data.driver_id)
          // this.drivers[oldItemIndex].name = isUpdated.name;
          oldItemIndex.name = isUpdated.data.firstname+" "+isUpdated.data.surname;

          console.log(isUpdated)
          }
          this.activeDriver = {}
      },
      driverPaggination (number) {
          this.driverNumber = number
      },
      changePerpage(event){
          if(event.target.value == this.drivers.length){
              this.perPage = this.drivers.length
          }else{
            this.perPage = event.target.value
          }

          this.setTotalPagginationLength()
      },
      setTotalPagginationLength () {
        this.driverTotal = paginationTotal(this.drivers.length,this.perPage)
      }
  },
  created: function () {
    this.getDrivers(true)


  },
  computed: {
      paginationDrivers: function () {
        return paginateList(this.drivers, this.driverNumber, this.perPage)
      }
  },
  watch:{
     perPage:function(){
          if(this.perPage == this.drivers.length){
            this.driverNumber =1;
          }
      }
    }
}
</script>
<style scoped>
.admin__driver__context{
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: hidden;
    text-align: left;
    box-sizing: border-box;
    position: relative;
}
th {
    width: 16%;
    border-collapse: collapse;
}
th span {
    display: flex;
    white-space: nowrap;
}
th div {
    display: inline-block;
    margin-left: 5px;
    position: relative;
}
.table__data {
    height: 50px;
}
table{
    border-collapse: separate;
    border-spacing: 0 8px;
    border-style: hidden;
}
td{
    cursor: pointer;
}
table {
    border-collapse: separate !important;
}
td {
    border: solid 1px transparent;
    background: rgba(235, 234, 244, 0.25);
}
table tr td:first-child {
    border-top-left-radius: 15px;
    border-left-width:15px;
    border-bottom-left-radius: 15px;
}
table tr td:last-child {
    border-top-right-radius: 15px;
    border-right-width:15px;
    border-bottom-right-radius: 15px;
}
.content {
    text-align: left;
    padding: 20px;
}
.content h1 {
    margin-top: 59px;
}
.table__content {
    margin-top: 58px;
}
.sort__up {
    position: absolute;
}
.header__style{
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: #1F1F1F;
}
.table__element{
    display: flex;
    padding: 0px 0px 5px 15px;
    background: rgb(235, 234, 244) none repeat scroll 0% 0%;
    opacity: 0.48;
    border-radius: 0.5em;
}
.search__content{
    text-align: right;
    margin-bottom: 25px;
}
.driver__hours__value { padding-left: 60px; }
.driver__payouts__value { padding-left: 40px; }
.driver__status__value { padding-left: 28px; }
.search__value__section, .perpage__value__section {
    background: #FFFFFF;
    border: 2px solid #2EA3FF;
    box-sizing: border-box;
    border-radius: 5px;
    margin-right: 15px;
    height: 34px;
    width: 200px;
    padding-left: 15px;
    color: #9F9F9F;
    font-weight: 600;
    font-size: 14px;
}
.btn__search {
    background: #2EA3FF;
    border: 2px solid #2EA3FF;
    border-radius: 5px;
    color: #fff;
    height: 34px;
    width: 86px;
    font-weight: 600;
    font-size: 13px;
}
.sort__image{
    widows: 17px;
    height: 7px;
    margin: 0 5px;
    cursor: pointer;
}
.search__content label{
    float:left;
}
@media only screen and (max-width: 1200px){
  .content h1 {
    margin-top: 20px;
     margin-bottom: 20px;
    }
    .search__content label{
        margin: 15px 0;
    }
}
@media only screen and (max-width: 1000px){
    .driver__hours__value {
        padding-left: 54px;
    }
}
@media only screen and (max-width: 950px){
    .driver__hours__value {
        padding-left: 38px;
    }
}
@media only screen and (max-width: 900px){
    th {
        font-size: 15px;
        padding-right: 5px;
    }
    .sort__image {
        height: 6px;
        top: 1px;
    }
}
@media only screen and (max-width: 790px){
    .driver__hours__value {padding-left: 32px;}
    .driver__payouts__value {padding-left: 34px;}
    .driver__status__value {padding-left: 26px;}
}
@media only screen and (max-width: 750px){
    td {
        font-size: 14px;
    }
}
@media only screen and (max-width: 730px){
    .search__content {
        text-align: left;
    }
    .sort__image {
        height: 5px;
        top: 3px;
    }
    .paginationContainer {
        float: left;
        padding-left: 0px;
    }
}
@media only screen and (min-width: 600px) and (max-width: 1024px) {

     .search__content label{
         margin:0 !important;
     }
     .btn__search{
        margin-right: 15px;
        margin-top: 10px;
     }
}
</style>
